import { CheckStat, EventState, RiskData } from '@nirvana/shared/dtos/types/compliance-reports/gz-console';

export interface ComplianceRiskRow extends RiskData {}

export type ComplianceAssetRow = {
  name: string;
  id: string;
  checksStats: CheckStat;
  state: EventState;
  riskScore: number;
};

export enum ComplianceEvents {
  DOWNLOAD_REPORT = 'download-report',
  SIDE_MENU_RISKS_DETAILS = 'side-menu-risks-details',
  SIDE_MENU_ASSETS_DETAILS = 'side-menu-assets-details',
  VIEW_MISCONFIGURATION_DETAILS = 'view-misconfiguration-details',
  VIEW_HUMAN_RISKS_BY_RISKS = 'view-human-risks-by-risks',
  VIEW_RESOURCES_BY_MISCONFIGURATIONS = 'view-resources-by-misconfigurations',
  VIEW_IDENTITIES_BY_RISKS = 'view-identities-by-risks',
  COMPLIANCE_GRID_DATA_LOADED = 'compliance-grid-data-loaded',
}

export type ControlsOverview = {
  controlDetails: {
    name: string;
    id: string;
    subId: string;
    description: string;
    controlResult: string;
    checksStat: {
      totalChecks: number;
      checksResults: {
        ignored: number;
        compliant?: number;
        nonCompliant?: number;
      };
      passedPercentage?: number;
    };
  };
  sectionDetails: {
    name: string;
    id: string;
  };
  category: string;
  findings: {
    misconfiguration: { indicatorIds: number[] };
    userBehaviorRisk: { indicatorIds: number[] };
  };
};
